import { useMemo } from 'react';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export const useKRPanelParamsMatch = () => {
  const location = useLocation();

  const { search } = location;

  return useMemo(() => {
    const { ids: idsString, type, showTaskDetails, objectivePId } = queryString.parse(search);

    if (objectivePId) {
      return {
        isOKRPanelOpen: true,
        isObjective: true,
        ids: [objectivePId],
      };
    }

    if (showTaskDetails !== 'true' || type !== 'GOAL') {
      return {
        isOKRPanelOpen: false,
        isObjective: false,
        ids: [],
      };
    }

    const idsArray = typeof idsString === 'string' ? idsString.split(',').filter((id) => id) : [];
    return {
      isOKRPanelOpen: idsArray.length > 0,
      isObjective: false,
      ids: idsArray,
    };
  }, [search]);
};
